module.exports = __webpack_public_path__ + "static/img/erweima.d1e74d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/imgs/erweima.jpg
// module id = ZXXI
// module chunks = 1